import React, { createContext, useContext, useMemo } from "react";
const BootstrapOptionsContext = createContext({
    noCloseModal: false
});
export function useBootstrapOptions() {
    return useContext(BootstrapOptionsContext);
}
export default function BootstrapOptionsProvider({ children, noCloseModal }) {
    const options = useMemo(() => ({ noCloseModal }), [noCloseModal]);
    return React.createElement(BootstrapOptionsContext.Provider, { value: options }, children);
}
